import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalsComponent } from '../modals.component';
import { BsModalRef } from "ngx-bootstrap/modal";
import { Product } from '@schoolbelle/api/purchase';
import { LedgerSummary } from '@schoolbelle/api/ledger';
import { Subscription } from 'rxjs';

@Component({
  selector: 'modal-place-order',
  templateUrl: './place-order-modal.component.html',
  styleUrls: ['./place-order-modal.component.css'],
  
})
export class PlaceOrderModalComponent extends ModalsComponent implements OnInit {
  type:'school'|'sms'|'test';
  products:Product[] = [];
  summary:LedgerSummary;
  purchase_type:'first'|'renewal';
  subscriptions = new Subscription();

  constructor(
    modalRef:BsModalRef,
    private cdRef:ChangeDetectorRef,
  ) {
    super(modalRef);
  }
  ngOnInit () {
  }

  data:any
  invalid:boolean;

  onUpdated (event:{data:any, invalid:boolean}) {
    const {data, invalid} = event;
    this.data = data;
    this.invalid = invalid;
    this.cdRef.detectChanges();
  }
  ok () {
    super.ok(this.data);
  }
}    